import jsPDF from "jspdf";
import logo from "../assets/kk_name.png";

export const DOCUMENT_PDF_CONFIG = {
  orientation: "p",
  unit: "pt",
  format: "letter",
  compress: true,
};

export const DOCUMENT_PDF_TABLE_OPTIONS = {
  headStyles: { fillColor: [66, 133, 244], textColor: 255, fontSize: 10 },
  styles: { fontSize: 10, textColor: 20, cellPadding: 6 },
  tableWidth: "auto",
  margin: { left: 40, right: 40 },
};

export const createDocumentPdf = () => new jsPDF(DOCUMENT_PDF_CONFIG);

export const applyDocumentHeader = (doc, title) => {
  try {
    const img = new Image();
    img.src = logo;
    doc.addImage(img, "PNG", 430, 26, 140, 40, undefined, "FAST");
  } catch {}

  doc.setFontSize(16);
  doc.text("Kiddie Kingdom Inc", 40, 40);
  doc.setFontSize(10);
  doc.text("19444 Business Center Dr, Northridge, CA 91324", 40, 58);
  doc.text("Phone: 818-818-4270", 40, 72);

  doc.setFontSize(18);
  doc.text(title, 40, 108);
  doc.setFontSize(11);
};
